function isCompositeNotebookEditorInput () {
  return false
}
export { isCompositeNotebookEditorInput };
